// 'use server';

import routes from '@config/routes';
import { serverFetcher } from '@instance';
import { CheckoutPayload, ShoppingCartStepEnum } from './types';

interface AddCartResponse extends CheckoutPayload {
  createdAt: string;
  updatedAt: string;

  id: number;
  uuid: string;
}

export const addShoppingCart = async (
  vals: CheckoutPayload
): Promise<AddCartResponse> => {
  try {
    const body = JSON.stringify({
      ...vals,
    });

    const response = await serverFetcher(routes.shoppingCart, {
      method: 'POST',
      body,
      // headers: { Authorization: `Bearer ${token}` },
    });

    return response;
  } catch (e) {
    console.log(e);
    throw e; // Re-throw the error after logging
  }
};

export const updateShoppingCart = async (
  cartId: string | number,
  payload: Partial<CheckoutPayload>
): Promise<AddCartResponse> => {
  try {
    const body = JSON.stringify({
      ...payload,
    });

    const response = await serverFetcher(routes.shoppingCartId(cartId), {
      method: 'PATCH',
      body,
      // headers: { Authorization: `Bearer ${token}` },
    });

    return response;
  } catch (e) {
    console.log(e);
    throw e; // Re-throw the error after logging
  }
};

export const getShoppingCartById = async (
  cartId: string | number
): Promise<AddCartResponse> => {
  try {
    const response = await serverFetcher(routes.shoppingCartId(cartId), {
      method: 'GET',
      // headers: { Authorization: `Bearer ${token}` },
    });

    return response;
  } catch (e) {
    console.log(e);
    throw e; // Re-throw the error after logging
  }
};

const copyShoppingCartPayload = (cart: CheckoutPayload): CheckoutPayload => ({
  userId: cart.userId,
  currentStep: ShoppingCartStepEnum.CHECKOUT,
  type: cart.type,
  packageConfigDetails: cart.packageConfigDetails,
  selectedHotelDetails: cart.selectedHotelDetails,
  selectedTicketDetails: cart.selectedTicketDetails,
  flightDetails: cart.flightDetails,
  bonusMarkupType: cart.bonusMarkupType,
  bonusMarkupValue: cart.bonusMarkupValue,
  refundableAccepted: cart.refundableAccepted,
  refundablePrice: cart.refundablePrice,
});

export const cloneShoppingCart = (cart: CheckoutPayload) =>
  addShoppingCart(copyShoppingCartPayload(cart));

export const cloneShoppingCartById = async (cartId: string | number) => {
  const cart = await getShoppingCartById(cartId);
  return cloneShoppingCart(cart);
};
